import React from "react";

import {AdaptivityContext} from "../assets/constants";
import axios from "axios";
import SaleDocs from "../saleDocs/SaleDocs";
import moment from "moment/moment";
import {
    Avatar,
    Caption,
    Cell, Chip,
    Div, ModalPage, ModalPageHeader, ModalRoot, Pagination,
    PanelHeader,
    PanelHeaderButton, RichCell,
    Search,
    Spinner,
    SplitCol,
    SplitLayout, Title,

} from "@vkontakte/vkui";
import {Icon24Cancel, Icon24ExpositionOutline, Icon24Search} from "@vkontakte/icons";

import * as constants from "../assets/constants";
import Fancybox from "../assets/fancybox";


class NewsList extends SaleDocs {


    constructor(props) {
        super(props);

    }

    componentDidMount = () => {

        moment.locale('ru')

        this.getItems()
        //      window.addEventListener("message", this.receiveMessage, false)
        if (!this.props.embedded) {
            window.addEventListener('scroll', this.handleScroll);
        }

    }
    componentWillUnmount = () => {

        if (!this.props.embedded) {
            window.removeEventListener('scroll', this.handleScroll);
        }
//        window.removeEventListener("message", this.receiveMessage)
    }
    getItems = (mainSearch = '', append, page) => {
        clearInterval(this.searchInterval);
        append = append == undefined ? false : append
        if (page == undefined) {
            page = this.state.page;
        }
        if (mainSearch == undefined) {
            mainSearch = this.state.mainSearch
        }
        let currentStatus = this.state.currentStatus

        this.setState({loading: true})
        let body = new FormData()
        body.append('sSearch', mainSearch)
        body.append('page', page)

        body.append('epp', AdaptivityContext.isMobile ? 10 : (this.props.is_firm_fit ? 5 : 8))


        axios.post(this.props.base_url + '?app=news&act=showManyJson', body,
            {
                withCredentials: true

            }
        ).then((response) => {
            this.setState({loading: false})
            let old = this.state.items;
            if (!append) {
                old = response.data.results
            } else {
                response.data.results.map((el, i) => {
                    old.push(el)
                })
            }

            this.setState({items: old})


            this.setState({cnt_items: response.data.iTotalRecords})
            this.setState({totalPages: response.data.iTotalPages})

            if (!this.props.embedded) {
                if (response.data.iTotalPages * 1 > 0) {
                    setTimeout(() => {
                        this.checkScroll()
                    }, 500)
                }
            }
        })
    }


    onClick_ = (e, index, id) => {
        e.stopPropagation()
        const item = this.state.items[index]
        this.setState({currentItemId: id, currentNewsOne: item})
        this.setActiveModal(constants.MODAL_LIST_OBJECTS)
    }

    render() {
        const images_url = this.props.base_url.replace("frontend/", '');


        const main_modals =
            <ModalRoot activeModal={this.state.activeModal}>


                {this.state.currentNewsOne && <ModalPage hideCloseButton={true}
                                                         id={constants.MODAL_LIST_OBJECTS}
                                                         onClose={this.modalBack}
                                                         settlingHeight={100}

                                                         header={
                                                             <ModalPageHeader
                                                                 after={<PanelHeaderButton
                                                                     onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}

                                                             >
                                                                 {this.state.currentNewsOne.title}
                                                             </ModalPageHeader>
                                                         }
                >

                    <Div>
                        <Caption>Дата публикации: {this.state.currentNewsOne.date}</Caption>
                        <hr />
                        <div dangerouslySetInnerHTML={{__html: this.state.currentNewsOne.text}}></div>
                        <hr />
                        <Fancybox key={'Defective0MonitoringFancyBox'}>
                            <div className="news-image">
                                {this.state.currentNewsOne.picture &&

                                    <a data-fancybox={'galleryNews'}
                                        href={images_url + this.state.currentNewsOne.picture}>
                                        {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                 size={AdaptivityContext.isMobile ? 260:400}
                                                 src={images_url+this.state.currentNewsOne.picture}/>}
                                    </a>
                                }
                            </div>
                        </Fancybox>
                    </Div>
                </ModalPage>}
            </ModalRoot>

        return (
            <SplitLayout modal={main_modals}>
                <SplitCol>

                    <Title>Новости</Title>
                    {this.state.items.map((item, index) => (
                        [<SplitLayout>
                            <SplitCol width={1}>
                                <RichCell subhead={item.date_only + ' ' + item.time}
                                          onClick={(e) => this.onClick_(e, index, item.id)}>
                                    {item.title}
                                </RichCell>
                            </SplitCol>
                        </SplitLayout>,

                            <hr/>]
                    ))}
                    {AdaptivityContext.isMobile ?
                        <div ref={this.ref} key="loader" style={{height: '50px', width: 'auto'}}>{this.state.loading ?
                            <Cell before="Запрашиваем данные с сервера"
                                  after={<Spinner size="large"/>}></Cell> : ""}</div> : this.state.loading ?
                            <Cell before="Запрашиваем данные с сервера" after={<Spinner size="large"/>}></Cell> : ""}
                    {this.state.totalPages > 1 && !AdaptivityContext.isMobile ?
                        <div style={{background: "whitesmoke", position: "fixed", bottom: "52px", zIndex: '99'}}>
                            <Pagination currentPage={this.state.page}
                                        totalPages={this.state.totalPages}
                                        onChange={this.setPage}/>
                        </div> : ''}
                </SplitCol>
            </SplitLayout>
        )
    }

}

export default NewsList